import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <label>
      Type
    </label>

    <@form.BasicRadioGroup
      @propertyName='heartFailureType'
      @translationKey='pathology.heart-failure-type'
      as |Group|
    >
      <Group.FieldRadio @value='systolic-heart-failure' />
      <Group.FieldRadio
        @value='heart-failure-with-preserved-ejection-fraction'
      />
    </@form.BasicRadioGroup>
  </div>

  <div class='two fields'>
    <div class='field'>

      <@form.Date
        @labelName='Date de diagnostic'
        @propertyName='diagnosticDate'
      />
    </div>
    <div class='field'>
      <label>
        Stade NYHA
      </label>
      <div class='four unstackable fields'>

        <@form.BasicRadioGroup @propertyName='nyhaStage' as |Group|>
          <Group.FieldRadio @label='1' @value='1' />
          <Group.FieldRadio @label='2' @value='2' />
          <Group.FieldRadio @label='3' @value='3' />
          <Group.FieldRadio @label='4' @value='4' />
        </@form.BasicRadioGroup>
      </div>
    </div>
  </div>

  <div class='field'>

    <@form.NumberInput
      @labelName='FEVG (%)'
      @propertyName='fevg'
      @min='0'
      @max='100'
    />
  </div>

  <div class='field'>

    <@form.Dropdown
      @labelName='Cardiopathie'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='amyloidosis-al' />
      <dropdown.Item @key='amyloidosis-aa' />
      <dropdown.Item @key='amyloidosis-ttr' />
      <dropdown.Item @key='hereditary-amyloidosis' />
      <dropdown.Item @key='ischemic-heart-disease' />
      <dropdown.Item @key='non-ischemic-dilated-cardiomyopathy' />
      <dropdown.Item @key='valvular-heart-disease' />
      <dropdown.Item @key='hypertrophic-cardiomyopathy' />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
